import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import SVNCounts from "../components/svnCounts";

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">ABOUT US</h1>

            <SVNCounts />

            <div className="flex flex-col md:flex-row items-center gap-8 my-6">
                {/* Image Section */}
                <div className="w-full md:w-1/2" data-aos="fade-up">
                    <img
                        src="https://img.freepik.com/free-vector/school-building-educational-institution-college_107791-1051.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
                        alt="School Building"
                        className="w-full rounded-lg shadow-lg"
                    />
                </div>

                {/* Content Section */}
                <div className="w-full md:w-1/2 space-y-4" data-aos="fade-up">
                    <p className="text-lg text-gray-700 leading-relaxed">
                        Welcome to <span className="text-green-600 font-semibold">SVN Convent</span>,
                        a place where young minds are nurtured with care, creativity, and knowledge.
                        Our school believes in fostering curiosity, critical thinking, and leadership
                        among students.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        With a dedicated faculty and a student-friendly environment, we strive to make
                        learning an exciting journey. We focus on holistic education, ensuring that every
                        child grows academically, socially, and emotionally.
                    </p>


                    {/* Button */}
                    <div className="mt-4">
                        <button className="bg-green-600 text-white px-6 py-2 rounded-lg font-semibold shadow-md hover:bg-green-700 transition duration-300">
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>

           <h1 className="text-3xl font-bold text-center py-6">Principal's Message</h1>
            <div className="flex flex-col md:flex-row  gap-8">
                {/* Image Section */}
                <div className="w-full md:w-1/2" data-aos="fade-up">
                    <img
                        src="https://img.freepik.com/premium-photo/photo-realistic-as-school-principal-with-bell-notice-board-concept-as-image-school-princ_980716-397728.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
                        alt="School Building"
                        className="w-full rounded-lg shadow-lg"
                    />
                    <div className="my-4 text-center">
                    <p className="text-lg font-semibold">Mr.Principal Name</p>
                    <p className="text-sm">Principal, SVN Convent </p>
                    </div>
                </div>

                {/* Content Section */}
                <div className="w-full md:w-1/2 space-y-4" data-aos="fade-up">
                    <p className="text-lg font-semibold text-gray-700 leading-relaxed">
                        “We believe in ‘Simple living and high thinking’.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        Every academic year brings forth new challenges and new opportunities. It requires dedication to pursue the goals of the institution. This can be done by not resting on past laurels – but to pursue with renewed vigour and enthusiasm.
                        Start by doing what is possible and you will find that you are doing the impossible. Every day brings forth new opportunities to learn more. At SVN CONVENT we make the learning experience meaningful and happy.
                        We believe that each child is unique and gifted and a child’s capacity to learn and create is infinite.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed">
                    In our School, the teachers and the administrative staff will make sure that your child learns to respect his school, family and his country. Teachers at school and parents at home are equal partners in providing a holistic education of the child.
                    Our endeavor is to teach each of our students to define success by overcoming the obstacles that come in their way and finding new paths to reach their goals.”
                    </p>


                    
                </div>
            </div>

            
        </div>
    );
};

export default About;
